import { query } from '@confluence/query-preloader-tools';

import { ReadTimeQuery } from './ReadTimeQuery.graphql';
import type {
	ReadTimeQuery as ReadTimeQueryType,
	ReadTimeQueryVariables,
} from './__types__/ReadTimeQuery';

export function preloadReadTime(contentId: ReadTimeQueryVariables['contentId'], useCache: boolean) {
	return query<ReadTimeQueryType, ReadTimeQueryVariables>({
		query: ReadTimeQuery,
		variables: {
			contentId,
		},
		fetchPolicy: useCache ? 'cache-first' : 'network-only',
	});
}
